import _sfc_main from "./BuyBoxPickupContext2.mjs";
/* empty css                      */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxPickupContext = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-777c8255"]]);
export {
  BuyBoxPickupContext as default
};
//# sourceMappingURL=BuyBoxPickupContext.mjs.map
